import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';
import { type W_Employee_FindAllForCompanyTable_QP_Filters } from './queryParams';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/table${`?query=${string}&additionalFilters=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/table`;

export const URL = (tableQuery: TableQuery, additionalFilters: W_Employee_FindAllForCompanyTable_QP_Filters): RouteDefinition => `${baseRoute}/table?query=${encodeURIComponent((JSON.stringify(tableQuery)))}&additionalFilters=${encodeURIComponent((JSON.stringify(additionalFilters)))}`;
